/* POD Archive Viewer - Shopify/Concept Edition
   Refined styling: rounded buttons, #171717 bg / white text, white hover / black text, fade transition
*/

(function() {

  var BASE = 'https://cdn.shopify.com/s/files/1/0698/5826/3091/files/';

  function initViewer(wrapId, images) {
    var wrap = document.getElementById(wrapId);
    if (!wrap) return;

    var state = { current: 0 };
    var cache = {};

    var imgEl        = wrap.querySelector('.pav-img');
    var captionEl    = wrap.querySelector('.pav-caption');
    var counterEl    = wrap.querySelector('.pav-counter');
    var prevBtn      = wrap.querySelector('.pav-prev');
    var nextBtn      = wrap.querySelector('.pav-next');
    var dotsContainer = wrap.querySelector('.pav-dots');

    if (!imgEl) return;

    var styleId = 'pav-style';
    if (!document.getElementById(styleId)) {
      var s = document.createElement('style');
      s.id = styleId;
      s.textContent = [
        '.pav-wrap { font-family: inherit; }',
        '.pav-img { display:block; width:100%; height:auto; transition:opacity 0.35s ease; }',
        '.pav-caption { margin-top:8px; font-size:13px; color:#555; min-height:1.4em; }',
        '.pav-counter { font-size:12px; color:#999; margin-top:4px; }',
        '.pav-prev, .pav-next {',
        '  background:#171717; color:#fff; border:2px solid #171717;',
        '  padding:9px 22px; font-size:12px; font-weight:700;',
        '  letter-spacing:0.08em; text-transform:uppercase; cursor:pointer;',
        '  border-radius:50px; transition:background 0.2s, color 0.2s, border-color 0.2s;',
        '  white-space:nowrap; flex-shrink:0;',
        '}',
        '.pav-prev:hover, .pav-next:hover {',
        '  background:#fff; color:#171717; border-color:#171717;',
        '}',
        '.pav-dot {',
        '  display:inline-block; width:8px; height:8px;',
        '  border-radius:50%; background:#ccc; cursor:pointer;',
        '  transition:background 0.2s, transform 0.2s; flex-shrink:0;',
        '}',
        '.pav-dot.active { background:#3399cc; transform:scale(1.25); }'
      ].join('\n');
      document.head.appendChild(s);
    }

    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (var d = 0; d < images.length; d++) {
        var dot = document.createElement('span');
        dot.className = 'pav-dot';
        dot.setAttribute('data-i', d);
        dotsContainer.appendChild(dot);
      }
    }

    function getDots() { return wrap.querySelectorAll('.pav-dot'); }

    function loadImage(index, callback) {
      if (cache[index]) { callback(cache[index]); return; }
      var img = new Image();
      img.onload = img.onerror = function() {
        cache[index] = images[index].src;
        callback(images[index].src);
      };
      img.src = images[index].src;
    }

    function show(index) {
      if (index < 0 || index >= images.length) return;

      imgEl.style.opacity = '0';

      loadImage(index, function(src) {
        imgEl.src = src;
        imgEl.alt = images[index].caption || '';
        imgEl.onload = function() { imgEl.style.opacity = '1'; };
        if (imgEl.complete && imgEl.naturalWidth) imgEl.style.opacity = '1';
      });

      if (captionEl) captionEl.textContent = images[index].caption || '';
      if (counterEl) counterEl.textContent = (index + 1) + ' / ' + images.length;

      if (prevBtn) prevBtn.style.opacity = index === 0 ? '0.4' : '1';
      if (nextBtn) nextBtn.style.opacity = index === images.length - 1 ? '0.4' : '1';

      var dots = getDots();
      for (var i = 0; i < dots.length; i++) {
        dots[i].className = 'pav-dot' + (i === index ? ' active' : '');
      }

      state.current = index;
      if (index + 1 < images.length) loadImage(index + 1, function() {});
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (state.current > 0) show(state.current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (state.current < images.length - 1) show(state.current + 1);
      });
    }

    wrap.addEventListener('click', function(e) {
      var target = e.target;
      var dot = target.closest ? target.closest('.pav-dot') : null;
      if (!dot && target.className && target.className.indexOf('pav-dot') !== -1) dot = target;
      if (dot) {
        var i = parseInt(dot.getAttribute('data-i'));
        if (!isNaN(i)) show(i);
      }
    });

    show(0);
  }

  function startViewers() {
    var B = 'https://cdn.shopify.com/s/files/1/0698/5826/3091/files/';

    initViewer('pav-wrap-v1', [
      { src: B+'moveMENT-03.jpg?v=1782618661', caption: 'Movement Issue 03 - 2004. Stewart: The Unanswered Questions. Fold-out cover.' },
      { src: B+'moveMENT-04.jpg?v=1782618662', caption: 'Movement Issue 04 - 2004. Mad Matt Lackey Profile.' },
      { src: B+'moveMENT-06.jpg?v=1782618659', caption: 'Movement Issue 06 - 2005. Hawaii. Yep, the old chestnut has done it again.' },
      { src: B+'moveMENT-07.jpg?v=1782618661', caption: 'Movement Issue 07 - 2005. The Big Bang All Photo Issue. Gunsmoke - The Dave Winchester Profile.' },
      { src: B+'moveMENT-08.jpg?v=1782618662', caption: 'Movement Issue 08 - 2005. Shark Island Challenge. The Wave of the Year.' },
      { src: B+'MOVEMENT-09.jpg?v=1782618661', caption: 'Movement Issue 09 - 2005. Exclusive 8 Page Poster. Mike and the Biggest Wave Ever at Teahupoo.' },
      { src: B+'moveMENT-10.jpg?v=1782618660', caption: 'Movement Issue 10 - 2005. Pure Gold.' },
      { src: B+'moveMENT-14.jpg?v=1782618661', caption: 'Movement Issue 14 - 2006. The Island. Secret South. The Knee. Super Tubes.' },
      { src: B+'Movement-15.jpg?v=1782618663', caption: 'Movement Issue 15 - 2006. Skipper and That Style. Tour Hits Chile.' },
      { src: B+'moveMENT-17.jpg?v=1782618661', caption: 'Movement Issue 17 - 2007. Ben Player, alt reverse as a seaplane trundles overhead.' },
      { src: B+'MOVEMENT-18.jpg?v=1782618661', caption: 'Movement Issue 18 - 2007. The Park From Above. The Film Crew Fly West.' },
      { src: B+'MOVEMENT-28.jpg?v=1782618662', caption: 'Movement Issue 28 - 2009. Young, Dumb and Free. Hawaii 0-9.' },
      { src: B+'MOVEMENT-31.jpg?v=1782618662', caption: 'Movement Issue 31 - 2009. Featuring Words and Design. 15 Bang Photos.' },
      { src: B+'MOVEMENT-41.jpg?v=1782618661', caption: 'Movement Issue 41 - 2012. Collectors Edition.' }
    ]);

    initViewer('pav-wrap-v2', [
      { src: B+'Movement-03-DP.jpg?v=1782618662', caption: 'Movement Issue 03 - Double page spread. John Cruickshank. Powered by POD Fins.' },
      { src: B+'Movement-04-DP.jpg?v=1782618662', caption: 'Movement Issue 04 - Double page spread. Matt Lackey. Powered by POD Fins.' },
      { src: B+'Movement-06-SP.jpg?v=1782618662', caption: 'Movement Issue 06 - Single page. John Cruickshank. Cutting It with Cruickshank.' },
      { src: B+'Movement-07-SP.jpg?v=1782618662', caption: 'Movement Issue 07 - Single page. Venture with Virtue. POD Fins.' },
      { src: B+'Movement-08-SP.jpg?v=1782618662', caption: 'Movement Issue 08 - Single page. Chris Wilson. Willpower with Wilson.' },
      { src: B+'Movement-09-DP.jpg?v=1782618660', caption: 'Movement Issue 09 - Double page spread. New POD Fins PF2. Product launch.' },
      { src: B+'Movement-10-DP.jpg?v=1782618660', caption: 'Movement Issue 10 - Double page spread. Chris Wilson. Chase It PF2.' },
      { src: B+'Movement-14-SP.jpg?v=1782618661', caption: 'Movement Issue 14 - Single page. Chris Wilson. Chase It PF2. Photo: Rod Owen.' },
      { src: B+'Movement-15-DP.jpg?v=1782618662', caption: 'Movement Issue 15 - Double page spread. Chris Wilson. Chase It PF2. Photo: Rod Owen.' },
      { src: B+'Movement-17-SP.jpg?v=1782618662', caption: 'Movement Issue 17 - Single page. John Cruickshank. Chase It PF2.' },
      { src: B+'Movement-18-3P-Foldout-jpg.jpg?v=1782618662', caption: 'Movement Issue 18 - Three-page foldout. Ash Bryant, POD Red Series Bicep Leash. Brenden Newton, Chase It PF3. Photo: Trent Mitchell.' },
      { src: B+'Movement-28-Back-COver.jpg?v=1782618662', caption: 'Movement Issue 28 - Back cover. Brenden Newton. Chase It PF3. Photo: Trent Mitchell.' },
      { src: B+'moveMENT-POD-ADvert-30.jpg?v=1782618660', caption: "Movement Issue 30 - Single page. POD Connection. World's Strongest." },
      { src: B+'Movement-31-SP.jpg?v=1782618662', caption: 'Movement Issue 31 - Single page. PF3. Proudly Our Direction.' },
      { src: B+'Movement-41-DP.jpg?v=1782618662', caption: 'Movement Issue 41 - Double page spread. Chris Wilson. Chase It PF3. Collectors Edition.' },
      { src: B+'moveMENT-SP-USA-copy.jpg?v=1782618661', caption: 'Movement - USA market copy. Chris Wilson. Chase PF2. Photo: Owen. USA distribution: Switchboard Inc, Santa Ana.' },
      { src: B+'moveMENT.jpg?v=1782618661', caption: 'Movement - issue unconfirmed. Matt Lackey. Powered by POD Fins.' },
      { src: B+'MOVEMENT-Ad.jpg?v=1782618662', caption: 'Movement - issue unconfirmed. John Cruickshank. Cruising with Cruickshank. Double page spread.' }
    ]);

    initViewer('pav-wrap-v3', [
      { src: B+'Riptide-134.jpg?v=1782618662', caption: 'Riptide Issue 134 - November 2003. The Accelerated Generation. Covershot: Winston McCall, Ballina.' },
      { src: B+'Riptide-142.jpg?v=1782618662', caption: 'Riptide Issue 142. The High Achievers Issue. The 2004 Peer Poll. Cover: Sean Virtue. Photo: Parker.' }
    ]);

    initViewer('pav-wrap-v4', [
      { src: B+'Riptide-131.jpg?v=1782618661', caption: 'Riptide Issue 131. Chris Wilson. SIC CUT. Powered by POD Fins. Photo: Owen.' },
      { src: B+'Riptide-133.jpg?v=1782618662', caption: 'Riptide Issue 133. John Cruickshank. SIC CUT. Powered by POD Fins. Photo: Owen.' },
      { src: B+'Riptide-134-SP.jpg?v=1782618662', caption: 'Riptide Issue 134 - Single page. John Cruickshank. SIC CUT. Powered by POD Fins.' },
      { src: B+'Riptide-135.jpg?v=1782618662', caption: 'Riptide Issue 135. Matt Lewis. SIC CUT. Powered by POD Fins.' },
      { src: B+'Riptide-136.jpg?v=1782618662', caption: 'Riptide Issue 136. Chris Wilson. SIC CUT. Powered by POD Fins. Photo: Owen.' },
      { src: B+'Riptide-137.jpg?v=1782618661', caption: 'Riptide Issue 137. Matt Lewis. SIC CUT. Powered by POD Fins.' },
      { src: B+'Riptide-140.jpg?v=1782618662', caption: 'Riptide Issue 140. Matt Lackey. Powered by POD Fins.' },
      { src: B+'Riptide-142-DP.jpg?v=1782618662', caption: 'Riptide Issue 142 - Double page spread. John Cruickshank. Powered by POD Fins. Hardware and Accessories Now Available.' }
    ]);

    initViewer('pav-wrap-v5', [
      { src: B+'Bodyboarder-1-1.jpg?v=1782618662', caption: 'Bodyboarder Magazine Issue 1.1. Hubb, New World Champ.' },
      { src: B+'Bodyboarder-1-2.jpg?v=1782618662', caption: 'Bodyboarder Magazine Issue 1.2. The Wedge - New Big Wednesday.' },
      { src: B+'Bodyboarder-2-3.jpg?v=1782618662', caption: 'Bodyboarder Magazine Issue 2.3. Oz Guide - The Top 7 Ozzie Spots.' },
      { src: B+'Bodyboarder-8-2.jpg?v=1782618662', caption: 'Bodyboarder Magazine Issue 8.2. Hawaii - The Pipe Contest. Botha is Loco.' },
      { src: B+'Bodyboarder-8-4.jpg?v=1782618660', caption: 'Bodyboarder Magazine Issue 8.4. Mitch is Next Level.' },
      { src: B+'Bodyboarder-9-2.jpg?v=1782618660', caption: 'Bodyboarder Magazine Issue 9.2. North Shore - Clean Crazy Times.' }
    ]);

    initViewer('pav-wrap-v6', [
      { src: B+'Bodyboarder-1-1-BC.jpg?v=1782618663', caption: 'Issue 1.1 - Back cover. Chris Wilson. Chase PF2. Photo: Ross Owen. USA: Switchboard Inc, Santa Ana.' },
      { src: B+'Bodyboarder-1-2-BC.jpg?v=1782618662', caption: 'Issue 1.2 - Back cover. John Cruickshank. Chase PF2. USA: Switchboard Inc. Hawaii: Joey Vieira.' },
      { src: B+'Bodyboarder-2-3-BC.jpg?v=1782618662', caption: 'Issue 2.3 - Back cover. Spencer Skipper. Chase It PF2. Photo: Todd Glaser.' },
      { src: B+'Bodyboarder-8-2-BC.jpg?v=1782618661', caption: 'Issue 8.2 - Back cover. Spencer Skipper. Chase It PF2 - SKIPP. Photo: Danny Black.' },
      { src: B+'Bodyboarder-8-4-BC.jpg?v=1782618661', caption: 'Issue 8.4 - Back cover. Rob Laurie. Chase It PF3.' },
      { src: B+'Bodyboarder-9-2-BC.jpg?v=1782618661', caption: 'Issue 9.2 - Back cover. Chris Wilson. Chase It PF3. Shipwreck location.' }
    ]);

    initViewer('pav-wrap-v7', [
      { src: B+'Rush-13.jpg?v=1782618661', caption: 'Rush Bodyboard Magazine Issue 13. 2003 Board Buyers Guide.' },
      { src: B+'Rush-13-SP.jpg?v=1782618662', caption: 'Rush Issue 13 - Single page. Matt Lewis. SIC CUT. Powered by POD Fins.' }
    ]);

    initViewer('pav-wrap-v8', [
      { src: B+'France-Bodyboard-Mag-1.jpg?v=1782618661', caption: "France - Bodyboard Magazine. Spencer Skipper. Chase It PF2. Distributor: Surf n'Com." },
      { src: B+'France-Bodyboard-Mag-03-2009.jpg?v=1782618661', caption: "France - Bodyboard Magazine 2009. Rob Laurie. Chase It PF3. Distributor: Surf'n Com, Lacanau." },
      { src: B+'France-Bodyboard-Mag-2010.jpg?v=1782618660', caption: 'France - Bodyboard Magazine 2010. Chris Wilson. Chase It PF3. Shipwreck location.' },
      { src: B+'France-Bodyboard-Mag-SKIPP-2008.jpg?v=1782618661', caption: 'France - Bodyboard Magazine 2008. Spencer Skipper. Chase It PF2. Lifestyle portrait.' },
      { src: B+'France-Bodyboard-Mag-2009.jpg?v=1782618661', caption: 'France - Bodyboard Magazine 2009. Rob Laurie. Chase It PF3. Portrait format.' },
      { src: B+'Flipper-Magazine.jpg?v=1782618661', caption: 'Japan - Flipper Magazine. Sean Virtue. Chase It PF1. Distributor: Maneverline Inc, Tokyo.' }
    ]);

    initViewer('pav-wrap-v9', [
      { src: B+'Vertical-with-VIRTUE.jpg?v=1782618662', caption: 'Publication unconfirmed. Sean Virtue. Vertical with Virtue. POD Fins.' }
    ]);

    initViewer('pav-wrap-v10', [
      { src: B+'John-Cruickshank-PF1.jpg?v=1782618721', caption: 'John Cruickshank - PF1. Film era. A perfectly formed barrel, shot from inside. The fins are on his feet and the wave is doing the rest.' },
      { src: B+'John-Cruickshank-PF1-POD-Fins.jpg?v=1782618720', caption: 'John Cruickshank - PF1, Bicep Leash. Deep in the tube on a yellow board. The leash cord is visible at the wrist. Composed and reading the wave.' },
      { src: B+'John-Cruickshank-PF2-Black-Yellow.jpg?v=1782618720', caption: 'John Cruickshank - PF2. Body arched back, arms extended, driving down the face on a yellow board. The lip is throwing hard above him.' },
      { src: B+'John-Cruickshank-PF2-Bicep.jpg?v=1782618720', caption: 'John Cruickshank - PF2, Bicep Leash. The fins are the subject here. His legs and the PF2s are all you can see above the whitewater. A rider in the foreground watches from the channel.' },
      { src: B+'Matt-Lackey-PF1.jpg?v=1782618720', caption: 'Matt Lackey - PF1. Film era. Inside a round, glassy barrel looking out toward the light. This shot is from early in the archive and the colour tells you so.' },
      { src: B+'Matt-Lewis-PF1.jpg?v=1782618720', caption: 'Matt Lewis - PF1. Film era. Hard bottom turn on a turquoise wave, arms wide and body fully committed to the line.' },
      { src: B+'Matt-Lewis-PF1s.jpg?v=1782618720', caption: 'Matt Lewis - PF1. Inside a fast, hollow barrel. Dark wetsuit, blue board, reading the tube with his arms out for trim.' },
      { src: B+'Ben-Horrocks-PF2.jpg?v=1782618719', caption: 'Ben Horrocks - PF2. One arm raised inside a heavy Indo barrel. Red board, blue fins, dark wetsuit. The lip is pitching hard above him.' },
      { src: B+'Chris-Wilson-PF2-Bicep.jpg?v=1782618720', caption: 'Chris Wilson - PF2, Bicep Leash. Clean Indo barrel, yellow board. Positioned well back in the tube, letting the wave come to him.' },
      { src: B+'Chris-Wilson-PF2-Bicep-Large.jpg?v=1782618720', caption: 'Chris Wilson - PF2, Bicep Leash. A different wave, the same understanding of where to be inside a tube. Yellow board, shot from the channel.' },
      { src: B+'Chris-Wilson-POD-Fins-2-Bicep.jpg?v=1782618720', caption: 'Chris Wilson - POD Fins, Bicep Leash. Driving a high line across a dark, heavy face. Blue rashie, blue board. The lip is throwing behind him.' },
      { src: B+'Chris-Wilson-PF3-Bicep.jpg?v=1782618720', caption: 'Chris Wilson - PF3, Bicep Leash. Launched well above the wave at a rocky Australian point. Red board, dark fins. A ship sits on the horizon.' },
      { src: B+'Kevin-Salkeld-PF3.jpg?v=1782618720', caption: 'Kevin Salkeld - PF3. Relaxed inside a clean barrel, looking forward through the tube. Yellow board, warm diffused light. One of the more composed shots in the archive.' },
      { src: B+'Brenden-Newton-PF3-BIcep.jpg?v=1782618720', caption: 'Brenden Newton - PF3, Bicep Leash. A thick Southern Ocean slab throwing hard over the rider. The scale of the wave dominates the frame.' },
      { src: B+'Rob-Laurie-PF3-Bicep.jpg?v=1782618720', caption: 'Rob Laurie - PF3, Bicep Leash. Full aerial above a beach break. Orange fins clearly visible. A faint rainbow sits in the spray in the upper frame.' },
      { src: B+'Morgan-Brown-PF3.jpg?v=1782618720', caption: 'Morgan Brown - PF3. Inverted above the whitewater, board and fins skyward. The most unusual frame in the archive. The fins are the only thing clearly readable.' },
      { src: B+'Sean-Virtue-PF2.jpg?v=1782618720', caption: 'Sean Virtue - PF2. Low and committed at the base of a large, cold-light wave. Blue board, body pressed to the water. A different mood to the rest of the set.' },
      { src: B+'Spencer-Skipper-PF2.jpg?v=1782618720', caption: 'Spencer Skipper - PF2. Clean barrel, warm light, right-hander. Looking forward through the tube. Composed and reading every section ahead.' }
    ]);

    initViewer('pav-wrap-v11', [
      { src: B+'Garth-McGregar-Bicep-Leash.jpg?v=1782618720', caption: 'Garth McGregor - X-Large Bicep Leash. Inside a large, clean barrel. Dark wetsuit, composed on the line. The image that shows exactly why he is a respected big wave rider.' },
      { src: B+'Damien-Martin-Bicep-Leash.jpg?v=1782618720', caption: 'Damien Martin - Bicep Leash. Low on the face of a heavy slab, golden side light. One of the larger waves in the archive. The leash is doing its job and nothing more needs to be said.' }
    ]);
  }

  function waitForViewers() {
    if (!document.getElementById('pav-wrap-v1') && !document.getElementById('pav-wrap-v10')) {
      setTimeout(waitForViewers, 300);
      return;
    }
    startViewers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForViewers);
  } else {
    waitForViewers();
  }

})();